import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';

const McpToolsAudio = observer((props) => {
  const {
    className = '',
    children,
    event,
  } = props;

  return (
    <div className={`${className}`} data-id={event?.planStepId}>
      <audio 
        className="mt-8px" 
        controls 
        preload="metadata"
        src={event.url}>
      </audio>
    </div>
  )
});
export default McpToolsAudio;